<template>
  <!-- coupon add -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      width='780px'
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
        :initReqHandle = 'initReqHandle'
        :isSubmitBtn="false"
      >
        <template slot="couponContent" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required  v-bind="$store.state.modal_ItemLayout">
            <a-radio-group v-model="hasThreshold">
              <a-radio :style="radioStyle" :value="1">
                满<a-input type='number' :style="inputStle" :disabled="hasThreshold!=1" v-model='Threshold'/>元，减<a-input type='number' v-model='fullReduction' :disabled="hasThreshold!=1" :style="inputStle"/>元
              </a-radio>
              <a-radio :style="radioStyle" :value="0">
                无门槛，减<a-input type='number' :style="inputStle" :disabled="hasThreshold!=0" v-model='discountAmount'/>元
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </template>

        <template slot="voucherUsageTime" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-radio-group v-model="voucherUsageTimeType">
              <a-radio :style="radioStyle" :value="1">
                  <a-range-picker
                    :show-time="{ format: 'HH:mm:ss' }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['用券开始时间', '用券结束时间']"
                    @ok="onOk"
                    :disabled="voucherUsageTimeType!=1"
                    v-model="timeFrame"
                  />
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                领券后，有效期<a-input type='number' v-model="validityPeriod" :style="inputStle" :disabled="voucherUsageTimeType!=2"/>天
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </template>
        <template slot="receiveNumberRestrictions" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-radio-group v-model="receiveNumberRestrictions" >
              <a-radio :value="1">
                每人领取次数不限
              </a-radio>
              <a-radio :value="2">
                每人最多可领<a-input type='number' v-model="upToClaim" :style="inputStle" :disabled="receiveNumberRestrictions!=2"/>次
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </template>
        <template slot="receiveUserRestrictions" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-radio-group v-model="receiveMemberLimit" >
              <a-radio :value="0">
                所有用户
              </a-radio>
              <a-radio :value="1">
                新用户
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </template>

        <template slot="applicableArea" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" has-feedback :help = "applicableAreaNote" :validateStatus ='applicableAreaVs' required v-bind="$store.state.modal_ItemLayout">
            <template>
                <a-tree-select
                  v-model="applicableArea"
                  style="width: 100%"
                  placeholder="请选择"
                  :tree-data="treeData"
                  tree-checkable
                  :show-checked-strategy="SHOW_PARENT"
                  search-placeholder="Please select"
                  @change="applicableAreaChange"
                />
            </template>
          </a-form-item>
        </template>
        <template slot="applicableCategories" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" has-feedback :help = "applicableCategoryNote" :validateStatus ='applicableCategoryVs' required v-bind="$store.state.modal_ItemLayout">
            <template>
                <a-tree-select
                  v-model="applicableCategory"
                  style="width: 100%"
                  placeholder="请选择"
                  :tree-data="classTreeData"
                  tree-checkable
                  :show-checked-strategy="SHOW_PARENT"
                  search-placeholder="Please select"
                  @change="applicableCategoryChange"
                />
            </template>
          </a-form-item>
        </template>
        <template slot="showPosition" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-checkbox v-model="showType">在领券中心可见</a-checkbox>
          </a-form-item>
        </template>

      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
import { TreeSelect } from 'ant-design-vue';
import Moment from 'moment';
const SHOW_PARENT = TreeSelect.SHOW_CHILD;
export default {
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      oldchoose: undefined,

      validateStatus: 'error',
      extranode: 'aaa',

      hasThreshold: 1,
      Threshold: undefined, // 满
      fullReduction: undefined, // 减
      discountAmount: undefined, // 无门槛

      voucherUsageTimeType: 1, // 用券时间类型
      timeFrame: undefined, // 有效期
      validityPeriod: undefined,

      applicableArea: undefined, // 适用区域
      applicableAreaNote: undefined,
      applicableAreaVs: 'sucess',
      applicableAreaOldchoose: undefined,

      applicableCategory: undefined, // 适用类型
      applicableCategoryNote: undefined,
      applicableCategoryVs: 'sucess',
      applicableCategoryOldchoose: undefined,

      receiveNumberRestrictions: 1, // 领取次数限制
      upToClaim: undefined, // 最多可领
      receiveMemberLimit: 0, // 领取用户限制 0所有用户  1新用户
      showType: true,

      treeData: [],
      classTreeData: [],
      SHOW_PARENT,
      inputStle: {
        width: '100px',
        margin: '0 6px 0 6px'
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        margin: '4px 0 10px 0'
      },
      initReqHandle: false,
      modalTitle: '添加优惠券',
      visible: false,
      formList: [
        {
          label: '业务类型',
          inputType: 'select',
          options: [],
          handle: e => this.businessTypeChange(e),
          placeholder: '请选择',
          props: ['businessType', {
            rules: [{ required: true, message: '请选择业务类型' }]
          }]
        },
        {
          label: '优惠券名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['couponName', {
            rules: [{ required: true, message: '请输入优惠券名称' }]
          }]
        },
        {
          slot: 'couponContent',
          label: '优惠内容',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        },
        {
          slot: 'voucherUsageTime',
          label: '用券时间',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        },
        {
          label: '发放总量',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入',
          props: ['publishNum', {
            rules: [{ required: true, message: '请输入发放总量' },
              { pattern: this.REG.positiveInt, message: '请输入正整数' }
            ]
          }]
        },
        {
          label: '适用类型',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['scopeType', {
            rules: [{ required: true, message: '请选择适用类型' }]
          }]
        },
        {
          slot: 'applicableArea',
          label: '适用区域',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        },
        {
          slot: 'applicableCategories',
          label: '适用类目',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        },
        {
          slot: 'receiveNumberRestrictions',
          label: '领取次数限制',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        }, {
          slot: 'receiveUserRestrictions',
          label: '领取用户限制',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        },
        {
          slot: 'showPosition',
          label: '展示',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['', {
            rules: [{ required: true, message: '' }]
          }]
        }

      ],
      formKey: {
      },
      addParam: {
        url: ''
      },
      editParam: {
        url: ''
      },
      detailParam: {
        url: ''
      }
    };
  },
  created () {
    this.getSelect();
  },
  computed: {
    window () {
      return window;
    }
  },
  methods: {
    businessTypeChange (e) {
      this.$refs.addEdit.form.setFieldsValue({scopeType: void 0});
      this.formList[5].options = [];
      this.$get({
        url: '/local/coupon/getScopeType',
        params: {
          type: e
        }
      }).then(({data}) => {
        this.formList[5].options = data;
      });
      if (e == 2) {
        setTimeout(() => {
          this.$refs.addEdit.form.setFieldsValue({scopeType: '0'});
        }, 500);
      }
      if (e == 3 || e == 4) {
        this.formList[7].isShow = false;
      } else {
        this.formList[7].isShow = true;
      }
    },
    onOk () {},
    applicableAreaChange (a, b, c) {
      let hasIndex = a.indexOf('0');
      if (hasIndex > -1) {
        this.applicableAreaOldchoose = a.filter(item => item != 0);
        this.applicableArea = ['0'];
        this.arrayaction(this.treeData, true);
      } else {
        this.arrayaction(this.treeData, false);
        if (this.applicableAreaOldchoose && this.applicableAreaOldchoose.length > 0) {
          this.applicableArea = this.applicableAreaOldchoose;
          this.applicableAreaOldchoose = [];
        }
      }
      if (a.length < 1 && this.applicableArea.length < 1) {
        this.applicableAreaNote = '请选择适用区域';
        this.applicableAreaVs = 'error';
      }
      if (a.length > 0 && this.applicableAreaNote) {
        this.applicableAreaNote = '';
        this.applicableAreaVs = 'success';
      }
    },
    applicableCategoryChange (a, b, c) {
      let hasIndex = a.indexOf('0');
      if (hasIndex > -1) {
        this.applicableCategoryOldchoose = a.filter(item => item != 0);
        this.applicableCategory = ['0'];
        this.arrayaction(this.classTreeData, true);
      } else {
        this.arrayaction(this.classTreeData, false);
        if (this.applicableCategoryOldchoose && this.applicableCategoryOldchoose.length > 0) {
          this.applicableCategory = this.applicableCategoryOldchoose;
          this.applicableCategoryOldchoose = [];
        }
      }
      if (a.length < 1 && this.applicableCategory.length < 1) {
        this.applicableCategoryNote = '请选择适用类目';
        this.applicableCategoryVs = 'error';
      }
      if (a.length > 0 && this.applicableCategoryNote) {
        this.applicableCategoryNote = '';
        this.applicableCategoryVs = 'success';
      }
    },

    arrayaction (arr, value) {
      arr.forEach(i => {
        if (i.value != 0) { i.disabled = value; }
        if (i.hasOwnProperty('children') && i.children) {
          this.arrayaction(i.children, value);
        }
      });
    },
    getSelect () {
      this.$get({
        url: '/regions/cityTreeAreaSelect'
      }).then(({data}) => {
        this.treeData = data;
      });
      this.$get({
        url: '/dict/data/dictType/comu_local_coupon_scope_type'
      }).then(({data}) => {
        this.formList[5].options = data;
      });
      this.$get({
        url: '/dict/data/dictType/comu_local_coupon_business_type'
      }).then(({data}) => {
        this.formList[0].options = data;
      });
      this.$get({
        url: '/local/leader/categoryTreeSelect',
        params: {
          type: 2
        }
      }).then(({data}) => {
        this.classTreeData = data;
      });
    },
    show () {
      this.window.scroll(0, 0);
      this.visible = true;
    },
    okFun () {
      let obj = {};
      let isPass = true;
      this.$refs.addEdit.form.validateFields((err, values) => {
        let noPass = false;
        if (!this.applicableArea || (this.applicableArea && this.applicableArea.length < 1)) {
          this.applicableAreaVs = 'error';
          this.applicableAreaNote = '请选择适用区域';
          noPass = true;
        }
        if (values.businessType != 3 && values.businessType != 4) {
          if (!this.applicableCategory || (this.applicableCategory && this.applicableCategory.length < 1)) {
            this.applicableCategoryVs = 'error';
            this.applicableCategoryNote = '请选择适用类目';
            noPass = true;
          }
        }
        if (err || noPass) {
          return;
        } else {
          if (this.hasThreshold == 1) {
            if (!this.Threshold || !this.fullReduction) {
              this.$message.error('请完善优惠内容');
              isPass = false;
            } else {
              if (this.fullReduction > 100000 || this.fullReduction < 0) {
                this.$message.error('满减金额为0-100000之间的正数');
                isPass = false;
              }
              if (this.Threshold > 100000 || this.Threshold < 0) {
                this.$message.error('满减金额为0-100000之间的正数');
                isPass = false;
              }
              obj.useLimit = this.Threshold;
              obj.price = this.fullReduction;
            }
          } else {
            if (!this.discountAmount) {
              this.$message.error('请完善优惠内容');
              isPass = false;
            } else {
              if (this.discountAmount <= 0) {
                this.$message.error('无门槛满减金额不能小于等于0');
                isPass = false;
              }
              obj.useLimit = -1;
              obj.price = this.discountAmount;
            }
          }
          if (this.voucherUsageTimeType == 1) {
            if (!this.timeFrame) {
              this.$message.error('请完善用券时间信息');
              isPass = false;
            } else {
              obj.expireType = 1;
              obj.startTime = Moment(this.timeFrame[0]).valueOf();
              obj.endTime = Moment(this.timeFrame[1]).valueOf();
            }
          } else {
            if (!this.validityPeriod) {
              this.$message.error('请完善用券时间信息');
              isPass = false;
            } else {
              if (this.validityPeriod % 1 > 0 || this.validityPeriod > 2000) {
                this.$message.error('有效期为1-2000之间的正整数');
                isPass = false;
              }
              obj.expireType = 2;
              obj.expireDays = this.validityPeriod;
            }
          }

          if (!this.applicableArea || (this.applicableArea && this.applicableArea.length < 1)) {
            this.applicableAreaVs = 'error';
            this.applicableAreaNote = '请选择适用区域';
            isPass = false;
          } else {
            obj.areaLimit = this.applicableArea.toString();
          }

          if (values.businessType != 3 && values.businessType != 4) {
            if (!this.applicableCategory || (this.applicableCategory && this.applicableCategory.length < 1)) {
              this.applicableCategoryVs = 'error';
              this.applicableCategoryNote = '请选择适用类目';
              isPass = false;
            } else {
              obj.categoryItemIds = this.applicableCategory;
              obj.categoryIds = this.findFatherNode(this.applicableCategory);
            }
          }

          if (this.receiveNumberRestrictions == 1) {
            obj.receiveNumLimit = '-1';
          } else {
            if (!this.upToClaim) {
              this.$message.error('请完善领取次数限制');
              isPass = false;
            } else {
              if (this.upToClaim % 1 > 0 || this.upToClaim > 100 || this.upToClaim < 1) {
                this.$message.error('领取次数为1-100之间的正整数');
                isPass = false;
              }
              obj.receiveNumLimit = this.upToClaim;
            }
          }
          if (!isPass) {
            return;
          }
        }
        obj.isShow = this.showType ? 1 : 0;
        obj.receiveMemberLimit = this.receiveMemberLimit;
        let newobj = {
          ...values,
          ...obj
        };
        this.$post({
          url: '/local/coupon',
          params: {
            ...newobj
          }
        }).then((res) => {
          this.$message.success('操作成功');
          this.closeFun();
          this.$parent.$refs.table.getTableList();
        });
      });
    },

    closeFun () {
      this.arrayaction(this.classTreeData, false);
      this.arrayaction(this.treeData, false);
      this.hasThreshold = 1;
      this.Threshold = undefined;
      this.fullReduction = undefined;
      this.discountAmount = undefined;

      this.voucherUsageTimeType = 1;
      this.timeFrame = undefined;
      this.validityPeriod = undefined;

      this.applicableArea = undefined;
      this.applicableAreaNote = undefined;
      this.applicableAreaVs = 'sucess';

      this.applicableCategory = undefined;
      this.applicableCategoryNote = undefined;
      this.applicableCategoryVs = 'sucess';

      this.receiveNumberRestrictions = 1;
      this.upToClaim = undefined;
      this.receiveMemberLimit = 0;
      this.showType = true;
      this.visible = false;

      this.applicableAreaOldchoose = [];
      this.applicableCategoryOldchoose = [];
    },
    findFatherNode (list) {
      let arr = [];
      this.classTreeData.forEach(item1 => {
        if (list.includes(item1.value)) {
          arr.push(item1.value);
        }
        if (item1.children && item1.children.length) {
          item1.children.forEach(item2 => {
            if (list.includes(item2.value)) {
              arr.push(item2.value);
              arr.push(item1.value);
            }
            if (item2.children && item2.children.length) {
              item2.children.forEach(item3 => {
                if (list.includes(item3.value)) {
                  arr.push(item3.value);
                  arr.push(item2.value);
                  arr.push(item1.value);
                }
                if (item3.children && item3.children.length) {
                  item3.children.forEach(item4 => {
                    if (list.includes(item4.value)) {
                      arr.push(item4.value);
                      arr.push(item3.value);
                      arr.push(item2.value);
                      arr.push(item1.value);
                    }
                  });
                }
              });
            }
          });
        }
      });
      arr = [...new Set(arr)];
      return arr;
    },
    ResHandle (res) {
      this.closeFun();
      return res;
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    addreqHandle (req) {
      return req;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
